import type { CSSProperties, ReactNode } from "react";
import css from "./AutoGrid.module.css";

/**
 * Fluid card grid (ADR 131): columns auto-fit to fill the available width, each
 * at least `min` px, so dashboards get denser on wide screens and reflow to one
 * column on a phone — no per-breakpoint column counts.
 */
export function AutoGrid({ min = 220, gap, className, children }: {
  min?: number;
  gap?: string;
  className?: string;
  children: ReactNode;
}) {
  const style = { "--auto-grid-min": `${min}px`, ...(gap ? { "--auto-grid-gap": gap } : {}) } as CSSProperties;
  return (
    <div className={className ? `${css.grid} ${className}` : css.grid} style={style}>
      {children}
    </div>
  );
}
